import { handleLocalApi } from '@/data/api/local-api'

export async function appFetch(input: RequestInfo | URL, init?: RequestInit) {
  const url = typeof input === 'string'
    ? new URL(input, globalThis.location?.origin || 'http://localhost')
    : input instanceof URL
      ? input
      : new URL(input.url)

  if (url.pathname.startsWith('/api/') && !url.pathname.startsWith('/api/v1/')) {
    return handleLocalApi(input, init)
  }
  return fetch(input, init)
}
